"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ParAffilatesAdminsAccessList = /** @class */ (function (_super) {
    __extends(ParAffilatesAdminsAccessList, _super);
    function ParAffilatesAdminsAccessList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Получил доступ',
                dataIndex: _this.props.data.dk_obtain_admin_login,
                key: _this.props.data.dk_obtain_admin_login,
                width: 200
            }, , {
                title: 'Предоставил доступ',
                dataIndex: _this.props.data.dk_grant_admin_login,
                key: _this.props.data.dk_grant_admin_login,
                width: 200
            }, {
                title: 'Дата предоставления доступа',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteAccessClick(record); } }))); },
                width: 100
            }
        ];
        return _this;
    }
    ParAffilatesAdminsAccessList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0
        }, function () {
            _this.props.data.LoadDataByGwsAffilateId(_this.props.record.key);
        });
        this.props.state.setExtBreadCrumbPath(["Настройка доступа к П.Программе"]);
    };
    ParAffilatesAdminsAccessList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    ParAffilatesAdminsAccessList.prototype.onDeleteAccessClick = function (record) {
        this.props.data.DoDeleteAccess(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0414\u043E\u0441\u0442\u0443\u043F \u0434\u043B\u044F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.obtain_admin_login,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u043A\u0440\u044B\u0442"));
        });
    };
    ParAffilatesAdminsAccessList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.props.data.LoadDataByGwsAffilateId(this.props.record.key);
        }
        if (action === "create") {
            this.props.dialog
                .SetOnCloseClick(function () { _this.props.dialog.Close(); })
                .SetOnSelectClick(function (key, val) {
                _this.props.data.DoAddAccess(_this.props.record.key, key, function () {
                    _this.props.dialog.Close();
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0414\u043E\u0441\u0442\u0443\u043F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 ",
                        React.createElement("b", null,
                            "[",
                            val,
                            "]"),
                        " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D"));
                });
            })
                .Show();
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    ParAffilatesAdminsAccessList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u0412\u0441\u0435\u0433\u043E : ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D :"),
                            "[",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0428\u043B\u044E\u0437 :"),
                            "[",
                            record.gws_affilate_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u0434\u043E\u0441\u0442\u0443\u043F :"),
                            "[",
                            record.grant_admin_login,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041F\u043E\u043B\u0443\u0447\u0438\u043B \u0434\u043E\u0441\u0442\u0443\u043F :"),
                            "[",
                            record.obtain_admin_login,
                            "]")));
                } })));
    };
    return ParAffilatesAdminsAccessList;
}(React.Component));
exports.default = ParAffilatesAdminsAccessList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/AffilateAdminsAccessList.tsx
// module id = 2012
// module chunks = 0